/**
 * This is the authCheck bundle entry point.
 * This file does an auth check in NWX as quickly as possible and redirects to gatekeeper if needed.
 */

import { authQuickCheck } from './auth-check';

// this immediate side-effect is intentional
(async () => {
  await authQuickCheck();
})();
